import { CarbonTrackFilters } from '@pages/sustainability/ui/carbon-track/models/carbon-track-filters.model';
import { CarbonTrack } from '@core/domain/model/sustainability/carbon-track.model';
import { OriginWarranty, OriginWarrantyFilters } from '@core/domain/model/sustainability/origin-warranty.model';

export interface SustainabilityState {
  carbonTrack: {
    error: string | null;
    filters: CarbonTrackFilters | null;
    data: CarbonTrack | null;
  };
  originWarranty: {
    error: string | null;
    filters: OriginWarrantyFilters | null;
    data: OriginWarranty | null;
  };
  summaryCarbonTrack: {
    filters: CarbonTrackFilters | null;
    data: CarbonTrack | null;
  };
}

export const sustainabilityInitialState: SustainabilityState = {
  carbonTrack: {
    error: null,
    filters: null,
    data: null,
  },
  originWarranty: {
    error: null,
    filters: null,
    data: null,
  },
  // SUSTAINABILITY-SUMMARY
  summaryCarbonTrack: {
    filters: null,
    data: null,
  },
};
